import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/zip.js
// module id = 717
// module chunks = 0